import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {mbeConfigService} from './mbe-config.service';
import { Observable } from 'rxjs';
import {BasicResponse} from '@auth-suite-services/services';
import {IStopActionReason, StopAction, StopActionAPI} from '../..';

@Injectable({
  providedIn: 'root'
})
export class StopActionService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(mbeConfigService) private config, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  getAllSac(pageIndex: number, pageSize: number, sortActive: string, sort: string, accountNumber: string): Observable<StopActionAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort; accountNumber');
    console.log(pageIndex, pageSize, sortActive, sort, accountNumber);
    const headers = this.headers;
    const JSONObj = {
      pageIndex: pageIndex,
      pageSize: pageSize,
      sortActive: sortActive,
      sort: sort,
      accountNumber: accountNumber,
    };
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<StopActionAPI>(`${this.URL}/sac/getallstopaction`,JSONObj, {headers});
  }

  getSac(id: number): Observable<StopAction> {
    console.log('SAC ID');
    console.log(id);
    const headers = this.headers;
    
    return this.httpClient.get<StopAction>(`${this.URL}/sac/getstopaction/${id}`, {headers});
  }


  getReason(): Observable<IStopActionReason[]> {
    const headers = this.headers;
    return this.httpClient.get<IStopActionReason[]>(`${this.URL}/sac/allreasons`, {headers});
  }

  updateSac(sac: StopAction): Observable<BasicResponse> {
    console.log('Update SAC' + JSON.stringify(sac));
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/sac/updatesac`, sac, {headers});
  }

  // Added new method to create a new SAC. 03/10/2025 PK.
  createSac(sac: StopAction): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.post<BasicResponse>(`${this.URL}/sac/createsac`, sac, {headers});
  }
}
